module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Fc-Gc-Hc-Ic-Ja.a966e4e7.png";